import type {PerformanceDurationContractEntry} from '../types';
import {panelBankSearchDataSettledDuration} from './panelBankSearchMarks';

/**
 * Register every performance duration here so the observer can pair its marks.
 */
export const REGISTERED_DURATION_CONTRACT_ENTRIES: readonly PerformanceDurationContractEntry[] =
  [...panelBankSearchDataSettledDuration.durationMarkEntries];
